export default __webpack_public_path__ + "static/Premio-home-desktop-987620eaf2e256bae9bc9453b5912ea5.png";